export const LOAD_USER_RIGHTS_STARTED = "LOAD_USER_RIGHTS_STARTED";
export const LOAD_USER_RIGHTS_SUCCESS = "LOAD_USER_RIGHTS_SUCCESS";
export const INVALIDATE_USER_RIGHTS = "INVALIDATE_USER_RIGHTS";
